import React, { useState, useEffect } from 'react';

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

const cardStyle = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '140px',
  width: '210px',
  padding: '14px 18px 14px 22px',
  background: '#ffffff',
  border: '0.5px solid #E5E7EB',
  borderRadius: '10px',
  overflow: 'hidden',
};

const accentStyle = {
  position: 'absolute',
  left: 0, top: 0, bottom: 0,
  width: '3px',
  borderRadius: '10px 0 0 10px',
  background: '#378ADD',
};

const tagStyle = {
  fontSize: '10px',
  fontWeight: '600',
  letterSpacing: '0.8px',
  textTransform: 'uppercase',
  color: '#9CA3AF',
  marginBottom: '8px',
};

const valueStyle = {
  fontSize: '22px',
  fontWeight: '500',
  color: '#185FA5',
  lineHeight: '1',
  marginBottom: '6px',
};

const subStyle = {
  fontSize: '12px',
  color: '#6B7280',
};

const Card4 = ({ title }) => {
  const [montantBacklog, setMontantBacklog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMontantBacklog = async () => {
      try {
        const response = await fetch(`${API}/montant_vente`);
        if (!response.ok) throw new Error(`Erreur HTTP : ${response.status}`);
        const data = await response.json();

        let montant = 0;
        if (Array.isArray(data)) {
          montant = data.reduce((acc, row) => {
            const val = parseFloat(row.Backlog ?? row.backlog ?? 0);
            return acc + (isNaN(val) ? 0 : val);
          }, 0);
        } else {
          montant = parseFloat(data.Backlog ?? data.backlog ?? data.total ?? 0);
        }

        setMontantBacklog(isNaN(montant) ? null : montant);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchMontantBacklog();
  }, []);

  const formattedValue = montantBacklog !== null
    ? new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(montantBacklog)
    : '—';

  return (
    <div style={cardStyle}>
      <div style={accentStyle} />
      <div style={tagStyle}>Backlog</div>
      <div style={valueStyle}>
        {loading ? 'Chargement…' : error ? 'Erreur' : formattedValue}
      </div>
      <div style={subStyle}>Commandes en cours</div>
    </div>
  );
};

export default Card4;